class NovaAccordion extends HTMLElement {
  constructor() {
    super();
    const titleElement = this.querySelector("[data-accordion-role=title]");
    const contentElement = this.querySelector("[data-accordion-role=content]");

    if (!titleElement) {
      throw new Error("Component is missing title element");
    }

    if (!contentElement) {
      throw new Error("Component is missing content element");
    }

    titleElement.onclick = () => {
      this.setAttribute("data-accordion-open", this.getAttribute("data-accordion-open") !== "true");
    };

    const config = {childList: true, subtree: true};

    const callback = mutationList => {
      for (const mutation of mutationList) {
        for (const node of mutation.addedNodes) {
          if (node.getAttribute && node.getAttribute("data-accordion-role") === "title") {
            node.onclick = () => {
              this.setAttribute("data-accordion-open", this.getAttribute("data-accordion-open") !== "true");
            };
          }
        }
      }
    };
    const observer = new MutationObserver(callback);

    observer.observe(this, config);
  }
}

if (!customElements.get("nova-accordion")) {
  customElements.define("nova-accordion", NovaAccordion);
}
